<template>
  <div class="analysis-card">
    <div class="main-content">
      <div class="y-axis-labels">
        <span>高效</span>
        <span>标准</span>
        <span>较慢</span>
      </div>
      <div class="quadrant-grid">
        <!-- 第一行：高效 -->
        <div class="row row-1">
          <div class="quadrant-cell" :class="{ 'highlight-cell': isHighlightCell('虎先锋') }" :style="getCellStyle('虎先锋')">
            <span>虎先锋</span>
            <div v-if="isHighlightCell('虎先锋')" class="checkmark">
              <el-image class="analysis_location" :src="iconPath('analysis_location.png')"></el-image>
              <el-image class="user_avatar" :src="iconPath('user_avatar.png')"></el-image>
            </div>
          </div>
          <div class="quadrant-cell" :class="{ 'highlight-cell': isHighlightCell('速度家') }" :style="getCellStyle('速度家')">
            <span>速度家</span>
            <div v-if="isHighlightCell('速度家')" class="checkmark">
              <el-image class="analysis_location" :src="iconPath('analysis_location.png')"></el-image>
              <el-image class="user_avatar" :src="iconPath('user_avatar.png')"></el-image>
            </div>
          </div>
          <div class="quadrant-cell" :class="{ 'highlight-cell': isHighlightCell('学霸') }" :style="getCellStyle('学霸')">
            <span>学霸</span>
            <div v-if="isHighlightCell('学霸')" class="checkmark">
              <el-image class="analysis_location" :src="iconPath('analysis_location.png')"></el-image>
              <el-image class="user_avatar" :src="iconPath('user_avatar.png')"></el-image>
            </div>
          </div>
        </div>

        <!-- 第二行：标准 -->
        <div class="row row-2">
          <div class="quadrant-cell" :class="{ 'highlight-cell': isHighlightCell('敷衍大师') }"
            :style="getCellStyle('敷衍大师')">
            <span>敷衍大师</span>
            <div v-if="isHighlightCell('敷衍大师')" class="checkmark">
              <el-image class="analysis_location" :src="iconPath('analysis_location.png')"></el-image>
              <el-image class="user_avatar" :src="iconPath('user_avatar.png')"></el-image>
            </div>
          </div>
          <div class="quadrant-cell" :class="{ 'highlight-cell': isHighlightCell('挑战者') }" :style="getCellStyle('挑战者')">
            <span>挑战者</span>
            <div v-if="isHighlightCell('挑战者')" class="checkmark">
              <el-image class="analysis_location" :src="iconPath('analysis_location.png')"></el-image>
              <el-image class="user_avatar" :src="iconPath('user_avatar.png')"></el-image>
            </div>
          </div>
          <div class="quadrant-cell" :class="{ 'highlight-cell': isHighlightCell('赶路人') }" :style="getCellStyle('赶路人')">
            <span>赶路人</span>
            <div v-if="isHighlightCell('赶路人')" class="checkmark">
              <el-image class="analysis_location" :src="iconPath('analysis_location.png')"></el-image>
              <el-image class="user_avatar" :src="iconPath('user_avatar.png')"></el-image>
            </div>
          </div>
        </div>

        <!-- 第三行：较慢 -->
        <div class="row row-3">
          <div class="quadrant-cell" :class="{ 'highlight-cell': isHighlightCell('路边的鼓掌人') }"
            :style="getCellStyle('路边的鼓掌人')">
            <span>路边的鼓掌人</span>
            <div v-if="isHighlightCell('路边的鼓掌人')" class="checkmark">
              <el-image class="analysis_location" :src="iconPath('analysis_location.png')"></el-image>
              <el-image class="user_avatar" :src="iconPath('user_avatar.png')"></el-image>
            </div>
          </div>
          <div class="quadrant-cell" :class="{ 'highlight-cell': isHighlightCell('薄发者') }" :style="getCellStyle('薄发者')">
            <span>薄发者</span>
            <div v-if="isHighlightCell('薄发者')" class="checkmark">
              <el-image class="analysis_location" :src="iconPath('analysis_location.png')"></el-image>
              <el-image class="user_avatar" :src="iconPath('user_avatar.png')"></el-image>
            </div>
          </div>
          <div class="quadrant-cell" :class="{ 'highlight-cell': isHighlightCell('攀登者') }" :style="getCellStyle('攀登者')">
            <span>攀登者</span>
            <div v-if="isHighlightCell('攀登者')" class="checkmark">
              <el-image class="analysis_location" :src="iconPath('analysis_location.png')"></el-image>
              <el-image class="user_avatar" :src="iconPath('user_avatar.png')"></el-image>
            </div>
          </div>
          <div class="quadrant-cell" :class="{ 'highlight-cell': isHighlightCell('匠心传承人') }"
            :style="getCellStyle('匠心传承人')">
            <span>匠心传承人</span>
            <div v-if="isHighlightCell('匠心传承人')" class="checkmark">
              <el-image class="analysis_location" :src="iconPath('analysis_location.png')"></el-image>
              <el-image class="user_avatar" :src="iconPath('user_avatar.png')"></el-image>
            </div>
          </div>
        </div>

        <div class="x-axis-labels">
          <span>0</span><span>20%</span><span>40%</span>
          <span>60%</span><span>80%</span><span>100%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatisticalAnalysisTable',
  props: {
    buyerUserId: {
      type: [String, Number],
      required: true,
    },
    courseId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      // 分析建议相关状态
      regenerateLoading: false,
      statisticalAnalysisData: {},
      analysisSuggestions: {
        studyDurationSuggest: '', // 学习时长分析建议
        abilitySuggest: '', // 能力阶梯分析建议
        knowledgeSuggest: '这是一个示例分析建议，显示用户在当前效率等级下的表现分析和改进建议。', // 知识点掌握率分析建议
        doAnswer: '', // 作答矩阵分析建议
        tutoringSuggest: '', // 老师分析建议
        courseId: this.courseId,
        buyerUserId: this.buyerUserId,
      },
    };
  },
  computed: {
    // 根据正确率和效率确定当前高亮的格子
    currentHighlightCell() {
      if (!this.statisticalAnalysisData.correctRate || !this.statisticalAnalysisData.efficiency) {
        return null;
      }

      const correctRate = this.statisticalAnalysisData.correctRate;
      const efficiency = this.statisticalAnalysisData.efficiency;

      if (efficiency === 'fast') {
        // 高效行
        if (correctRate >= 0 && correctRate < 60) {
          return '虎先锋';
        } else if (correctRate >= 60 && correctRate < 80) {
          return '速度家';
        } else if (correctRate >= 80 && correctRate <= 100) {
          return '学霸';
        }
      } else if (efficiency === 'centre') {
        // 标准行
        if (correctRate >= 0 && correctRate < 60) {
          return '敷衍大师';
        } else if (correctRate >= 60 && correctRate < 80) {
          return '挑战者';
        } else if (correctRate >= 80 && correctRate <= 100) {
          return '赶路人';
        }
      } else if (efficiency === 'slow') {
        // 较慢行
        if (correctRate >= 0 && correctRate < 40) {
          return '路边的鼓掌人';
        } else if (correctRate >= 40 && correctRate < 60) {
          return '薄发者';
        } else if (correctRate >= 60 && correctRate < 80) {
          return '攀登者';
        } else if (correctRate >= 80 && correctRate <= 100) {
          return '匠心传承人';
        }
      }

      return null;
    },
  },
  mounted() {
    // 初始化示例数据
    // this.initExampleData();
  },
  methods: {
    // 初始化示例数据
    initExampleData() {
      // 示例数据 - 可以根据需要修改这些值来测试不同的效果
      this.statisticalAnalysisData = {
        correctRate: 90, // 正确率 75%
        efficiency: 'centre' // 效率等级：fast(高效), centre(标准), slow(较慢)
      };
    },
    
    // 判断是否是高亮格子
    isHighlightCell(cellName) {
      return this.currentHighlightCell === cellName;
    },
    
    // 获取格子样式
    getCellStyle(cellName) {
      const baseStyles = {
        '虎先锋': { background: '#D7C2F7' },
        '速度家': { background: '#FFF29A' },
        '学霸': { background: '#D9F1CF' },
        '敷衍大师': { background: '#EBE9FF' },
        '挑战者': { background: '#FFF3F4' },
        '赶路人': { background: '#FDDBCE' },
        '路边的鼓掌人': { background: '#FFBABD' },
        '薄发者': { background: '#D0F3EF' },
        '攀登者': { background: '#FFEECE' },
        '匠心传承人': { background: '#F9D3E8' }
      };

      if (this.isHighlightCell(cellName)) {
        // 高亮样式 - 颜色加深
        const darkenStyles = {
          '虎先锋': { background: '#8A5DC6', color: 'white' },
          '速度家': { background: '#E6C800', color: 'white' },
          '学霸': { background: '#7DC45C', color: 'white' },
          '敷衍大师': { background: '#8A7EFF', color: 'white' },
          '挑战者': { background: '#FF6B7A', color: 'white' },
          '赶路人': { background: '#FF8C5A', color: 'white' },
          '路边的鼓掌人': { background: '#FF4757', color: 'white' },
          '薄发者': { background: '#00C2A8', color: 'white' },
          '攀登者': { background: '#FFB400', color: 'white' },
          '匠心传承人': { background: '#E84393', color: 'white' }
        };
        return darkenStyles[cellName];
      }

      return baseStyles[cellName];
    },
    
    // 处理分析建议操作
    handleSuggestionCommand(command) {
      if (command === 'manual') {
        // 触发编辑事件
        this.$emit('open-edit-dialog', {
          ...this.analysisSuggestions,
          saveSuggestion: this.saveSuggestion
        });
      } else if (command === 'ai') {
        // 模拟重新生成分析建议
        this.regenerateLoading = true;
        setTimeout(() => {
          this.analysisSuggestions.knowledgeSuggest = '重新生成的AI分析建议：用户当前处于标准效率等级，正确率为75%，建议加强基础练习以提高效率。';
          this.regenerateLoading = false;
          this.$message.success('分析建议已重新生成');
        }, 1500);
      }
    },
    
    // 保存建议
    saveSuggestion(suggestionText) {
      this.analysisSuggestions.knowledgeSuggest = suggestionText;
      this.$message.success('分析建议已保存');
    },
  },
};
</script>

<style scoped lang="scss">
.analysis-card {
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  font-size: 16px;
  color: #303030;
  margin-bottom: 15px;
}

.main-content {
  display: flex;
  flex-grow: 1;
  gap: 10px;
}

.y-axis-labels {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-size: 14px;
  color: #909090;
  text-align: right;
  padding-right: 10px;
  height: 240px;
}

.quadrant-grid {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid #EEE;
  height: 240px;
}

.row {
  display: flex;
  flex: 1;
  width: 100%;
}

.row-1 .quadrant-cell:nth-child(1) {
  flex: 0.6;
  /* 0-60% */
}

.row-1 .quadrant-cell:nth-child(2) {
  flex: 0.2;
  /* 60-80% */
}

.row-1 .quadrant-cell:nth-child(3) {
  flex: 0.2;
  /* 80-100% */
}

.row-2 .quadrant-cell:nth-child(1) {
  flex: 0.6;
  /* 0-60% */
}

.row-2 .quadrant-cell:nth-child(2) {
  flex: 0.2;
  /* 60-80% */
}

.row-2 .quadrant-cell:nth-child(3) {
  flex: 0.2;
  /* 80-100% */
}

.row-3 .quadrant-cell:nth-child(1) {
  flex: 0.4;
  /* 0-40% */
}

.row-3 .quadrant-cell:nth-child(2) {
  flex: 0.2;
  /* 40-60% */
}

.row-3 .quadrant-cell:nth-child(3) {
  flex: 0.2;
  /* 60-80% */
}

.row-3 .quadrant-cell:nth-child(4) {
  flex: 0.2;
  /* 80-100% */
}

.quadrant-cell {
  display: flex;
  // flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: #606060;
  position: relative;
  border: 1px solid #EEE;
  height: 100%;
  box-sizing: border-box;
  transition: all 0.3s ease;

  &.highlight-cell {
    color: white;
    font-weight: bold;
  }
}

.checkmark {
  font-size: 16px;
  font-weight: bold;
  margin-top: 4px;
  position: relative;
}
.analysis_location{
  width:29px;
  // height:43px;
}
.user_avatar{
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  top: 6px;
  left: 6px;
}

.x-axis-labels {
  position: absolute;
  bottom: -25px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #909090;
}

.x-axis-title {
  position: absolute;
  bottom: -45px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  color: #909090;
}
</style>